import { connect } from "react-redux";
import { ThunkDispatch, ThunkAction } from "redux-thunk";
import { SearchThunk } from "../../store/actions/SearchThunk";
import { IContentBySearchState, IPagination } from "../../store";
import { Pagination } from "../presentation/Pagination";

interface PropsFromState {
    pagination: IPagination;
}

interface PropsFromDispatch {
    search: (next: boolean) => void;
}

interface OwnProps {
}

const mapStateToProps = (state: IContentBySearchState) => ({
    pagination: state.pagination
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, any>) => ({
    search: (next: boolean) => dispatch(SearchThunk(false, next))
});

export const PaginationContainer = connect<PropsFromState, PropsFromDispatch, OwnProps>(mapStateToProps, mapDispatchToProps)(Pagination);